import {RefObject} from 'react';

export type IsMobileViewProps = {isMobileView: boolean};

export type NextButtonRefType = RefObject<HTMLButtonElement> | null;

export const nextButtonClickHandler = (ref: RefObject<HTMLButtonElement> | null) => ref?.current?.click();
